import axios from "axios";
import { useQuery } from "react-query";

import { MaterialConfig } from "../types/domain";

interface ProductsProducedResponse {
  group: string;
  materials: MaterialConfig[];
}

const getProducts = (productCategory: string) =>
  axios
    .get<ProductsProducedResponse[]>("materials/products", {
      params: { productCategory },
    })
    .then((res) => res.data?.[0].materials);

const useProducts = (productCategory = "ProductsProduced") =>
  useQuery(["products", productCategory], () => getProducts(productCategory), {
    staleTime: Infinity,
  });

export default useProducts;
